import { parseRequestError } from '@/common/utilities.ts'
import axios from 'axios'
import { RequestResponse } from '@/common/types_and_interfaces.ts'
import {
  PaginatedRoles,
  PaginatedRolesSchema,
  RolePermissionList,
  UpdateRolePermissionsReq,
  RolePermissionListSchema,
  UpdateRolePermissionsRes,
  UpdateRolePermissionsResSchema,
  UpdateRoleReq,
  CreateRoleSchema,
  CreateRole,
} from './schemas.ts'

export const getRoles = async (programId?: number): Promise<PaginatedRoles> => {
  try {
    const response = await axios.get('roles', {
      params: { program_id: programId },
    })
    const data = response.data || { data: [] }
    return PaginatedRolesSchema.parse(data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

// get Role Permissions

export const getRolePermissionsDetail = async (
  roleId?: number | null
): Promise<RolePermissionList> => {
  try {
    const response = await axios.get(`roles_permission/${roleId}`)
    return RolePermissionListSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

// create Role
export const createRole = async (
  name: string,
  code: string,
  description: string
): Promise<CreateRole> => {
  try {
    const response = await axios.post('/roles', { name, code, description })
    return { data: CreateRoleSchema.parse(response.data), error: null }
  } catch (e) {
    new Error(parseRequestError(e).message)
    return { data: null, error: parseRequestError(e).message }
  }
}

// update Role Permissions

export const UpdateRolePermissions = async (
  requestBody: UpdateRolePermissionsReq,
  role_id: number
): Promise<RequestResponse<UpdateRolePermissionsRes>> => {
  try {
    const response = await axios.post(
      `roles_permissions_update/${role_id}`,
      requestBody
    )
    const cleanResponse = UpdateRolePermissionsResSchema.parse(response.data)
    return { data: cleanResponse, error: null }
  } catch (error) {
    return { data: null, error: parseRequestError(error) }
  }
}

// update Role

export const UpdateRole = async (
  requestBody: UpdateRoleReq,
  role_id: number
) => {
  try {
    const response = await axios.put(`roles/${role_id}`, requestBody)
    return response
  } catch (error) {
    return { data: null, error: parseRequestError(error) }
  }
}
